module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("Y")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("ou’ve ")]), _vm._v("got to be nuts if you don’t like dog snuggles. There’s nothing better than waking up late on a Saturday morning with a warm, fluffy dog sleeping right beside you. I love when that dog lifts its head and then drops it back down, happy to be lying in your comfy bed, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sure, sometimes the dog stretches and pushes you over the edge. Sometimes you wake up to find your face squashed against your dog’s rear end. But dog snuggles are the best.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The trouble is that I never get to wake up next to a dog because our Labradors never let me get to sleep in the first place. Our chocolate Lab, Cocoa, has always vibrated with energy. And ever since we adopted Nilla, our yellow Lab, and Licorice, our black Lab, all three dogs have decided they like camping out with me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s why I’m so tired while pushing the broom around the old mill my family runs to make our authentic Colonial-era chocolates. The waterwheel turns. The gears clink, clink, clink. And I push my broom slower than a zombie wading in caramel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You missed the corners, kiddo,” Grandpa says as I bump into his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry,” I grumble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know it doesn’t sound like it, but the past few months at the mill have been great.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandpa Irving makes chocolate the way we learned to do it from my great-great-great-great-(however many times)-grandmother’s cookbook, which we found behind one of the walls of our house.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad works in the store. It’s been busy, busy, busy with people who can’t resist buying our melt-in-your-mouth chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mom is the food artist. She takes Grandpa’s big bricks of chocolate and turns them into her famous bite-size candies. She grabs a bunch of ingredients you’d never think of putting together and creates something that makes you think you’ve skipped the dying part and gone straight to heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As for my sister, Hannah, she’s too busy to spend much time in the shop since she’s gotten involved in animal rescue. She sets up rides for dogs that need to find forever homes. Every Saturday, she meets Ms. Shaw’s van to help walk the dogs and give them water. She also brings along a bag of treats for all those excited little guys.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Try not to kick up so much dust,” Grandpa says with a smile. “This store is cloudier than it was behind the artillery line at the Battle of Yorktown.” Grandpa is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("way")]), _vm._v(" into American history. He even dresses up sometimes and joins in reenactments of the Revolutionary War.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I try to sweep more carefully, but it’s tough. The way people made chocolate three hundred years ago is very different from the way we do it now. Although we try to remove the shells from the cocoa beans neatly, they still get everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I circle back and carefully sweep out the corners, happy that Mom and Dad told me I could start working here. I mostly like it because I can earn some money, but it’s fun to hang out in a working chocolate mill anyway. I put in a few hours each day after school and four or five on the weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bell over the door jingles, and Hannah barges in with Cocoa, Nilla, and Licorice. My sister tosses her backpack on a bench and the dogs start sniffing around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When will our dogs understand they’re not getting any chocolate?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think they ever will. It smells so good!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sweep a pile of cocoa shells into my dustpan and dump it into the trash. “Too bad chocolate makes dogs sick,” I say. “Could you imagine being around it all the time and not being able to eat a bite?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hannah pops a square of plain chocolate into her mouth and smiles. “Nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I grab a cloth and start wiping down the glass pane that visitors look through to see the gears under the mill. Right in the middle, the gear my friend Alan Kunkle and I designed on his 3-D printer smiles at me like a rainbow pinwheel. The mill wouldn’t work without it, and it’s holding up better than anyone expected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And none of this would be working without our dogs, that run inside the waterwheel to help get things spinning. They’re holding up amazingly well, too!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I move over to the glass case that displays Beatrice Cabot’s old cookbook. It sits open to a page where she drew her chocolate-making setup: the heavy chocolate grindstone, her mortar and pestle, and her winnowing basket. A bright red ribbon lies across the page, and I can imagine Great-Great-Great-Great-(however many times)-Grandma Beatrice using it to hold her place in her favorite book.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I polish the display case, I hear the crunch of gravel in the driveway. A black limousine pulls up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wonder who that could be!” Hannah squeals. “Maybe it’s the president! Or better yet, Taylor Swift!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver, a big, burly man in a black hat, gets out. He walks around the car and opens the rear door. A bony man appears. He pushes his floppy brown hair to the side and smooths his jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not this jack-a-ninny again,” Grandpa mutters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who is it?” I ask, resting on my broom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes narrow to slits. “The British are coming, Mason. The British are coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man walks along the path that leads to the mill and steps onto the porch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s when Cocoa, Nilla, and Licorice pull free from Hannah’s grasp and burst outside. The door swings open and knocks the man back. He tumbles over the railing into a bush. Now all I can see are his legs sticking straight into the air. His pink-and-blue polka-dot socks make me want to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he finally crawls out and Grandpa doesn’t offer him a hand, I know trouble is brewing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af7ea04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781338184655_ch001.vue
// module id = 66
// module chunks = 0